import React from 'react'
import { useConfig } from 'msp-integrations'

type CheckboxProps = {
  className?: string
  labelStyle?: string
  disabled?: boolean
  id?: string
  label?: React.ReactNode | string
  name: string
  onChange?: (e: any) => void
  type?: string
  value: boolean
  hasError?: boolean
  isDarkMode?: boolean
}

const CustomCheck = () => (
  <svg
    viewBox='-1.5 0 22 20'
    height='18px'
    width='18px'
    className='absolute'
    fill='inherit'
  >
    <path
      d='M16.5417 6.01214L7.70841 14.8022C7.63018 14.8807 7.52368 14.9248 7.41258
14.9248C7.30148 14.9248 7.19498 14.8807 7.11675 14.8022L2.62508 10.3325C2.5462 10.2547
2.50183 10.1487 2.50183 10.0381C2.50183 9.92758 2.5462 9.82161 2.62508 9.74376L3.20841
9.16328C3.28665 9.08479 3.39315 9.04064 3.50425 9.04064C3.61535 9.04064 3.72184 9.08479
3.80008 9.16328L7.40841 12.7539L15.3667 4.83461C15.5316 4.67557 15.7936 4.67557 15.9584
4.83461L16.5417 5.42337C16.6206 5.50123 16.665 5.6072 16.665 5.71776C16.665 5.82831
16.6206 5.93429 16.5417 6.01214Z'
    />
  </svg>
)

const Checkbox = ({
  className = '',
  labelStyle = 'text-14 leading-16 font-GoodPro tracking-0.2',
  disabled = false,
  id,
  label,
  name,
  onChange,
  type = 'checkbox',
  value,
  hasError,
  isDarkMode = false,
  ...rest
}: CheckboxProps) => {
  const {
    theme: {
      font,
      mspComponents: { checkbox }
    }
  } = useConfig()

  const checkboxStyle = checkbox?.getStyles(isDarkMode)

  return (
    <label
      htmlFor={name}
      className={`${labelStyle} ${font.regular} ${
        disabled ? 'cursor-default' : 'cursor-pointer'
      } my-2 inline-flex w-fit items-center ${className} ${
        hasError && 'text-errorRed'
      }`}
    >
      <div
        className={`mr-3 h-5 min-h-[20px] w-5 min-w-[20px] cursor-pointer rounded-sm border ${
          disabled
            ? `pointer-events-none cursor-default ${checkboxStyle.disabledCheckStyle}`
            : checkboxStyle?.enabledCheckStyle
        } ${value && checkboxStyle.valueTrueStyle} ${
          hasError && 'border-errorRed'
        } relative`}
      >
        {value && <CustomCheck />}
      </div>
      <input
        {...rest}
        id={id ?? name}
        checked={value}
        className={'pointer-events-none hidden appearance-none'}
        disabled={disabled}
        name={name}
        type={type}
        onChange={onChange && ((e) => onChange(e.target.checked))}
      />
      <span className='m-0 h-fit select-none'>{label}</span>
    </label>
  )
}

export default Checkbox
